import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e7513bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-pwreset l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "パスワードリセット", -1))
const _hoisted_4 = { class: "ha__sec ha-pwreset__sec" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__lead" }, [
  /*#__PURE__*/_createTextVNode("ご登録済みのメールアドレスを入力してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" パスワード再設定ページのURLをお送りいたします。")
], -1))
const _hoisted_6 = { class: "p-signin__field-container" }
const _hoisted_7 = { class: "p-errors" }
const _hoisted_8 = { class: "c-error" }
const _hoisted_9 = { class: "p-fields" }
const _hoisted_10 = { class: "c-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "email"
}, "集英社ID（メールアドレス）", -1))
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input" }
const _hoisted_14 = { class: "c-field has-submit has-mt" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワードリセット", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__txt" }, "ドメイン指定受信をご利用の方は「mail.id.shueisha.co.jp」をあらかじめ許可してください", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Form, {
          onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.forgotPassword, this))),
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors, meta }) => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errorMsgRef), 1)
              ], 512), [
                [_vShow, _ctx.errorMsgRef]
              ]),
              _createElementVNode("fieldset", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Field, {
                        type: "text",
                        id: "email",
                        name: "email",
                        modelValue: _ctx.emailRef,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailRef) = $event)),
                        placeholder: "******@**.**.jp",
                        autocomplete: "email",
                        required: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.email), 513), [
                  [_vShow, errors.email]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "ha-btn is-submit",
                    disabled: !meta.valid || _ctx.isDeterringRef
                  }, _hoisted_17, 8, _hoisted_15)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"]),
        _hoisted_18
      ])
    ])
  ]))
}